import React, { Component } from "react";
import BrandingLogo from "../components/common/BrandingLogo";
import { navLinks } from "../services/navLinkService";
import ListGroup from "./navListGroup";
import { getCurrentUser } from "../services/userService";
import NetworkStatus from "../components/common/networkStatus";
import { applyTheme, getPreferredTheme, setTheme } from "../services/themeService";

class NavBar extends Component {
  state = {
    greeting: '',
    links: [],
    selectedLink: null,
    networkStatus: false,
    loading: true,
    error: null,
    user: null,
    showNav: false,
    theme: "light",
  };

  async getCurrentUser() {
    try {
      const { data: user } = await getCurrentUser();
      let greeting = `Welcome, ${user.Contact.fullname}!`;
      this.setState({ greeting, loading: false, user });
    } catch (error) {
      this.setState({ error: 'Failed to load user data', loading: false });
    }
  }

  async componentDidMount() {
    this.setState({ links: navLinks });

    const selected = {}
    this.setState({ selectedLink: selected });

    this.getCurrentUser();

    const theme = getPreferredTheme();
    applyTheme(theme);
    this.setState({ theme });
  }

  handleLinkSelect = link => {
    this.setState({ selectedLink: link });
  };

  toggleNav = () => {
    this.setState({ showNav: !this.state.showNav });
  };

  toggleTheme = () => {
    const theme = this.state.theme === "dark" ? "light" : "dark";
    setTheme(theme);
    this.setState({ theme });
  };

  render () {
    const { user } = this.state;
    const { loading, error, greeting } = this.state;

    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-md navbar-light bg-light sticky-top shadow-sm d-flex align-items-center">
          <a className="navbar-brand" href="/client/#">
            <BrandingLogo colorTheme={this.state.theme} maxHeight="40px" />
          </a>
          
          <button
            onClick={this.toggleNav}
            className="navbar-toggler d-flex justify-content-center align-items-center border-0 bg-transparent d-block d-md-none ml-auto"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ height: "40px" }}
          >
            <i className={this.state.showNav ? "fa fa-times" : "fa fa-bars"}></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="container-fluid d-block d-md-none">
              {user && (
                <button
                  type="button"
                  className="btn btn-link text-secondary pl-0"
                  onClick={this.props.onHelpOpen}
                >
                  <i className="fa fa-question-circle mr-2" /> Help
                </button>
              )}
              {user && (
                <ListGroup
                  items={this.state.links}
                  selectedItem={this.state.selectedLink}
                  onItemSelect={(link) => {
                    this.handleLinkSelect(link);
                    document.getElementById('navbarNavAltMarkup').classList.toggle('show');
                    this.setState({ showNav: !this.state.showNav });
                  }}
                />
              )}
            </div>
          </div>
          
          <div className="navbar-actions ml-auto d-none d-md-flex">
            <div className="navbar-greeting">
              {loading ? <span>Loading...</span> : error ? <span>{error}</span> : greeting}
            </div>
            <div className="navbar-action">
              <NetworkStatus />
            </div>
            <button
              type="button"
              className="navbar-icon-button text-secondary"
              onClick={this.props.onHelpOpen}
              aria-label="Open help"
              title="Open help"
            >
              <i className="fa fa-question-circle" />
            </button>
            <div className="navbar-action">
              <i
                className={(this.state.theme === "dark" ? "fa fa-sun-o" : "fa fa-moon-o") + " navbar-icon clickable"}
                role="button"
                tabIndex={0}
                onClick={this.toggleTheme}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") this.toggleTheme();
                }}
                aria-label={this.state.theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
                title={this.state.theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              ></i>
            </div>
          </div>

        </nav>
      </React.Fragment>
    );
  }
};

export default NavBar;
